(function () {
  'use strict';

  function patchEmbedPreselect(embed) {
    if (!embed || embed.getAttribute('data-toee-preselect-patched') === 'true') {
      return false;
    }

    var raw = embed.getAttribute('upsell-app-data');
    if (!raw) {
      return false;
    }

    try {
      var data = JSON.parse(raw);
      if (!data || !Array.isArray(data.funnels)) {
        return false;
      }

      var changed = false;
      data.funnels.forEach(function (funnel) {
        if (funnel && funnel.upsell && funnel.upsell.isPreselectProducts === true) {
          funnel.upsell.isPreselectProducts = false;
          changed = true;
        }
      });

      embed.setAttribute('data-toee-preselect-patched', 'true');
      if (changed) {
        embed.setAttribute('upsell-app-data', JSON.stringify(data));
      }
      return changed;
    } catch (err) {
      return false;
    }
  }

  function patchAllEmbeds(root) {
    var scope = root || document;
    if (!scope.querySelectorAll) {
      return;
    }

    scope.querySelectorAll('essential-upsell-app-embed[upsell-app-data]').forEach(function (embed) {
      patchEmbedPreselect(embed);
    });
  }

  function uncheckRenderedSelections(root) {
    var scope = root || document;
    if (!scope.querySelectorAll) {
      return;
    }

    scope.querySelectorAll('[data-essential-upsell] input[type="checkbox"]:checked').forEach(function (input) {
      input.checked = false;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function handleAddedNode(node) {
    if (!(node instanceof Element)) {
      return;
    }

    if (node.matches && node.matches('essential-upsell-app-embed[upsell-app-data]')) {
      patchEmbedPreselect(node);
    } else {
      patchAllEmbeds(node);
    }

    uncheckRenderedSelections(node);
  }

  patchAllEmbeds(document);

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(handleAddedNode);
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    patchAllEmbeds(document);
    uncheckRenderedSelections(document);
  });
})();
